import { template } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import Dropdown from 'ember-simplepractice/components/spds/action/button/dropdown';
export default class LocaleSwitcher extends Component {
    @service
    localeManager;
    onItemClick = (event1)=>{
        const value1 = event1.target.dataset.value;
        this.localeManager.setLocale(value1);
    };
    static{
        template(`
    <Dropdown @onItemClick={{this.onItemClick}} data-test-locale-switcher ...attributes>
      <:trigger>
        {{this.localeManager.currentLocaleFlag}}
        {{this.localeManager.currentLocaleName}}
      </:trigger>
      <:menu as |menu|>
        {{#each this.localeManager.availableLocales as |locale|}}
          <menu.Item @value={{locale.code}} data-test-locale-option={{locale.code}}>
            {{locale.flag}}
            {{locale.name}}
          </menu.Item>
        {{/each}}
      </:menu>
    </Dropdown>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
